import React from 'react';
import { calculateFormMatch, ROUTE_LABELS } from '../../lib/testCalculations';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', morado:'#534AB7', verde:'#1D9E75' };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const glass = { background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:16 };
const ROUTE_COLORS = { tiempo:C.turquesa, productos:C.mango, activos:C.morado };

export default function MyShortlist({ forms, choices, userRadar }) {
  const siChoices = choices.filter(c => c.status === 'si');
  const talVezChoices = choices.filter(c => c.status === 'tal_vez');
  const noChoices = choices.filter(c => c.status === 'no');

  const siFormsWithMatch = siChoices
    .map(c => {
      const forma = forms.find(f => f.id === c.form_id);
      if (!forma) return null;
      return { ...forma, matchPct: calculateFormMatch(forma, userRadar) };
    })
    .filter(Boolean)
    .sort((a, b) => b.matchPct - a.matchPct);

  return (
    <div>
      <h2 style={{ fontFamily:serif, fontSize:22, fontWeight:400, margin:'0 0 8px' }}>Mi selección</h2>
      <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', margin:'0 0 20px', fontFamily:font }}>
        Tu progreso eligiendo entre las 31 formas.
      </p>

      {/* Summary counters */}
      <div style={{ display:'flex', gap:10, marginBottom:24 }}>
        {[
          { label:'Sí', count:siChoices.length, color:C.verde },
          { label:'Tal vez', count:talVezChoices.length, color:C.mango },
          { label:'No', count:noChoices.length, color:C.coral },
          { label:'Sin evaluar', count:31 - choices.length, color:'rgba(255,255,255,0.3)' },
        ].map((s, i) => (
          <div key={i} style={{ flex:1, padding:'14px 10px', borderRadius:12, background:'rgba(255,255,255,0.03)', border:`0.5px solid ${s.color}30`, textAlign:'center' }}>
            <p style={{ fontSize:24, fontWeight:600, margin:'0 0 2px', color:s.color, fontFamily:font }}>{s.count}</p>
            <p style={{ fontSize:11, color:'rgba(255,255,255,0.5)', margin:0, fontFamily:font }}>{s.label}</p>
          </div>
        ))}
      </div>

      {/* Si list */}
      {siFormsWithMatch.length > 0 ? (
        <div>
          <p style={{ fontSize:13, fontWeight:500, color:C.verde, margin:'0 0 12px', fontFamily:font }}>
            ✓ Mis favoritas ({siFormsWithMatch.length})
          </p>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {siFormsWithMatch.map((forma, i) => {
              const routeColor = ROUTE_COLORS[forma.route] || C.turquesa;
              return (
                <div key={forma.id} style={{ ...glass, padding:'14px 18px', display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{
                    width:36, height:36, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
                    background: forma.matchPct >= 70 ? 'rgba(29,158,117,0.15)' : 'rgba(253,190,2,0.15)',
                    fontSize:12, fontWeight:600, fontFamily:font,
                    color: forma.matchPct >= 70 ? C.verde : C.mango,
                  }}>
                    {forma.matchPct}%
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:2 }}>
                      <span style={{ fontSize:9, fontWeight:600, padding:'2px 6px', borderRadius:50, background:`${routeColor}15`, color:routeColor, fontFamily:font }}>
                        {forma.route?.toUpperCase()}
                      </span>
                      <p style={{ fontSize:14, fontWeight:500, margin:0, fontFamily:font }}>{forma.name}</p>
                    </div>
                    <p style={{ fontSize:12, color:'rgba(255,255,255,0.4)', margin:0, fontFamily:font }}>
                      ${forma.income_min}-${forma.income_max} USD/mes
                    </p>
                  </div>
                  {i < 5 && (
                    <span style={{ fontSize:10, padding:'3px 8px', borderRadius:50, background:'rgba(253,190,2,0.12)', color:C.mango, fontFamily:font, fontWeight:600 }}>
                      Top {i + 1}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div style={{ ...glass, padding:'40px 20px', textAlign:'center' }}>
          <p style={{ fontSize:32, margin:'0 0 8px' }}>🗺️</p>
          <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', margin:0, fontFamily:font }}>
            Todavía no has seleccionado favoritas. Explora las formas y marca "Sí me resuena".
          </p>
        </div>
      )}
    </div>
  );
}
